import React, { useState } from "react";
import { Nav, Offcanvas } from "react-bootstrap";
import MyVerticallyCenteredModal from "./EventModal";
import './custom.css'
function OffCanvasExample({ name, ...props }) {
    const [show, setShow] = useState(false);
    const [modalShow, setModalShow] = React.useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div className="d-block d-md-none overflow-hidden">
            {
                !show ? <button onClick={handleShow} className="me-2 fs-2" style={{ border: 'none', background: 'transparent', color: 'white' }}>
                    <i className="fa fa-bars" aria-hidden="true"></i>
                </button> : <span></span>
            }
            <Offcanvas style={{ background: "rgba(0,0,0, 0.9)", width: '100vw' }} show={show} onHide={handleClose} {...props}>
                <Offcanvas.Header className="text-light">
                    <div><img
                        src='/img/Vaultus-removebg-preview 1.png'
                        className='w-100 '
                        alt=''
                    /></div>
                    {show ? <i className="fa fa-times" onClick={handleClose} aria-hidden="true" style={{ fontSize: '30px', padding: '20px', cursor: 'pointer' }}></i> : <p style={{ padding: '27px' }}></p>}
                </Offcanvas.Header>
                <Offcanvas.Body className="mt-3">
                    <Nav.Link className="mt-2" onClick={handleClose} style={{ fontFamily: "Poppins", fontWeight: "400", fontSize: "16px", color: "#FFFFFF" }} href='#theClub'>The Club </Nav.Link>
                    <Nav.Link className="mt-2" onClick={handleClose} style={{ fontFamily: "Poppins", fontWeight: "400", fontSize: "16px", color: "#FFFFFF" }} href='#mining'>Mining</Nav.Link>
                    <Nav.Link className="mt-2" onClick={handleClose} style={{ fontFamily: "Poppins", fontWeight: "400", fontSize: "16px", color: "#FFFFFF" }} href='#green'>Green Bitcoin</Nav.Link>
                    <Nav.Link className="mt-2" onClick={handleClose} style={{ fontFamily: "Poppins", fontWeight: "400", fontSize: "16px", color: "#FFFFFF" }} href='#'>Benefits</Nav.Link>
                    <Nav.Link className="mt-2" onClick={handleClose} style={{ fontFamily: "Poppins", fontWeight: "400", fontSize: "16px", color: "#FFFFFF" }} href='#white-papers'>White Papers</Nav.Link>
                    <Nav.Link className="mt-2" onClick={handleClose} style={{ fontFamily: "Poppins", fontWeight: "400", fontSize: "16px", color: "#FFFFFF" }} href='#timeline'>Timeline</Nav.Link>
                    <div className='mt-5'>
                        <button onClick={() => setModalShow(true)} className='navBtn'>Membership</button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    );
}


const RespNav = () => {
    return (
        <>
            {['end'].map((placement, idx) => (
                <OffCanvasExample key={idx} placement={placement} name={placement} />
            ))}
        </>
    );
};

export default RespNav;